<template>
    <div class="o-badges u-w100 u-py20 u-overflowYAuto">
        <div class="o-badges__inner u-container">
            <div v-if="!loading" class="o-badges__content">
                <div v-for="(badgeList, category) in badges" :key="category" class="o-badges__category">
                    <div v-if="badgeList.badges.length > 0" class="o-badges__content">
                        <h2 class="o-badges__title u-colorSecondary">
                            {{ badges[category].name }} {{ $t('profile.badges').toLowerCase() }}
                        </h2>
                        <div class="o-badges__list u-grid -cols3 u-mb20 -colGap25">
                            <Badge
                                v-for="badge in badgeList.badges"
                                :key="badge.badge_number"
                                :badge-number="badge.badge_number"
                                :module-title="badge.module_title"
                                :category="category"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '../services/api';

// Components
import Badge from '../components/atoms/Badge.vue';

const badges = ref([]);
const loading = ref(true);

const fetchBadges = async () => {
    try {
        const response = await api.get('/badges');

        if (response.status === 200 && Object.keys(response.data).length !== 0) {
            badges.value = response.data;
        }
        loading.value = false;
    } catch (error) {
        console.error('Error fetching badges:', error);
        loading.value = false;
    }
};

onMounted(() => {
    fetchBadges();
});
</script>
